<fgb-mobile-page-header
  [pageTitle]="'wallet.page.title'"
  backButtonLink="/"
  [showQr]="false"
  [showBalance]="false"
  [showAppleWallet]="true"
/>
<div class="mobile-container">
  <div class="container wallet-background">
    <div class="d-flex pt-4 position-relative campaign-wrapper">
      <div class="d-lg-flex d-none">
        <div class="pb-3">
          <div class="text-white cursor-pointer d-none d-lg-flex btn-circle-gloss bg-glass" (click)="backButton()">
            <span class="material-icons pe-1">arrow_back_ios_new</span>
          </div>
        </div>
      </div>
      <!-- Image -->
      <div class="img-wrapper">
        <div class="loyalty-details-image rounded overflow-hidden p-0">
          <img
            [ngClass]="{
              'image-opacity': currentCampaign.campaignRedemptions_Quantity == 0,
            }"
            alt=""
            [src]="currentCampaign.image_URL"
            class="logo"
          />
        </div>
        <div class="back-button icon-placement">
          <ng-container *ngIf="currentCampaign.campaignRedemptions_Quantity == 0">
            <span class="back-button icon material-icons text-white text-end fw-bold ms-3 font-size-20"> lock </span>
          </ng-container>
          <ng-container *ngIf="currentCampaign.campaignRedemptions_Quantity > 0">
            <span class="back-button icon material-icons text-success text-end fw-bold ms-3"> check_circle </span>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Name -->
    <div class="text-center text-white font-size-14 fw-bold mt-3">{{ currentCampaign.CampaignName }}</div>
    <!-- Expiry -->
    <div class="font-size-12 text-white text-center pt-lg-2 pt-0">
      {{ 'offer.expiry' | translate }} {{ currentCampaign.Campaign_ExpiryDate | date: 'MMM dd, yyyy' }}
    </div>
    <!-- Description -->
    <hr class="border-top border-disabled my-3" />
    <label class="pt-2 text-white mb-2">{{ 'offer.description' | translate }}</label>
    <div class="font-size-14 text-white">{{ currentCampaign.PortalDescription }}</div>
  </div>
</div>
